import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs } from '@components/navigation/Breadcrumb.tsx';
import OrderList from '@features/client/orders/OrderList.tsx';
import UpcomingRunsBanner from '@features/client/scheduled-orders/UpcomingRunsBanner.tsx';
import UserLayout from '@components/layout/UserLayout.tsx';
import { z } from 'zod';
import { useOrderStore } from '@features/client/orders/orderStore.ts';
import { OrderStatus } from '@api/generated/search-service';

const orderSearchSchema = z.object({
  query: z.string().optional(),
  orderStatus: z.nativeEnum(OrderStatus).optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
});

export type OrderSearchParams = z.infer<typeof orderSearchSchema>;

export const Route = createFileRoute('/c/$orgId/$portalId/orders/')({
  validateSearch: search => orderSearchSchema.parse(search),
  beforeLoad: ctx => {
    useOrderStore.getState().fetchOrders({
      query: ctx.search.query,
      orderStatus: ctx.search.orderStatus,
      dateFrom: ctx.search.dateFrom,
      dateTo: ctx.search.dateTo,
      page: ctx.search.page,
      size: ctx.search.size,
    });
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('client');

  return (
    <UserLayout>
      <div className="mb-8">
        <Breadcrumbs items={[{ label: t('orders.breadcrumb'), href: undefined }]} />
        <div className="flex items-center justify-between mb-2 mt-4">
          <h1 className="text-3xl font-bold text-main">{t('orders.pageTitle')}</h1>
        </div>
        <p className="text-light">{t('orders.pageDescription')}</p>
      </div>

      {/* Co se chystá odeslat z plánovaných objednávek — jinak o tom uživatel neví,
          dokud objednávka nevznikne. Když není co ukázat, nevykreslí se nic. */}
      <div className="mb-6">
        <UpcomingRunsBanner />
      </div>

      <OrderList />
    </UserLayout>
  );
}
